import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import appRoutes from './routes';
import HelpAssistant from './components/HelpAssistant';

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            {appRoutes.map((route) => (
              <Route key={route.path} path={route.path} element={route.element} />
            ))}
          </Routes>
          <HelpAssistant />
        </BrowserRouter>
      </LanguageProvider>
    </div>
  )
}

export default App;
